import * as React from 'react';

export default function Avalanche(props) {
  const { width = 150, height = 150, primary = '#FF394A' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 257 227">
      <path
        d="M160.944 226.789H246.964C254.554 226.789 259.304 218.569 255.504 211.999L212.494 137.509C208.694 130.939 199.214 130.939 195.414 137.509L152.404 211.999C148.604 218.569 153.354 226.789 160.944 226.789Z"
        fill={primary}
      />
      <path
        d="M171.704 66.8581L136.354 5.61809C132.784 -0.571914 123.844 -0.571914 120.274 5.61809L1.38358 211.538C-2.52642 218.318 2.36358 226.778 10.1836 226.778H80.9736C88.5236 226.778 95.4936 222.748 99.2636 216.218L171.704 90.7481C175.974 83.3581 175.974 74.2481 171.704 66.8581Z"
        fill={primary}
      />
    </svg>
  );
}